
<img
    class="tw-top-6 tw-right-9 md:tw-top-10 md:tw-left-9 tw-absolute tw-cursor-pointer xl:tw-ml-[25px] xl:tw-w-[40px]"
    [mat-dialog-close]="true"
    ga-event-id="popup_1_imsme_hp_click"
    ga-event-category="Homepage Button"
    ga-event-label="Popup Welcome at Homepage"
    ga-track="track"
    src="../../../../../assets/images/announcement-close.svg"
    alt="Announcement close"
    (click)="toHomePage()"
/>

<img
    src="/assets/images/logo/header_desktop.webp"
    alt="logo"
    ga-event-id="imsme_top_button_hp_click"
    ga-event-category="Homepage Button"
    ga-event-label="IMSME Icon Home Button Top"
    ga-track="track"
    class="tw-absolute tw-top-14 -tw-translate-x-2/4 md:tw-translate-x-0 tw-left-2/4 md:tw-left-auto md:tw-top-10 md:tw-right-12 tw-h-[75px] tw-w[151px] tw-cursor-pointer"
    (click)="toHomePage()"
/>

<mat-dialog-content id="announcement-wrapper" class="announcement-bg tw-h-full">
    <div class="tw-ml-0 xl:tw-ml-14">
        <div class="tw-flex tw-flex-wrap tw-mt-[6rem] tw-items-center tw-pt-10 md:tw-pt-5">
            <div class="tw-basis-full md:tw-basis-1/2 md:tw-mr-16">
                <h3
                    class="headings-text tw-hidden md:tw-hidden xl:tw-hidden"
                >
                    {{ "ANNOUNCEMENTS.HEADINGS" | translate }}
                </h3>
                <img
                    src="../../../../../assets/images/slider-home/Popup BM.webp"
                    class="tw-w-[413px]" alt="Popup BM"
                />
            </div>
            <div class="tw-basis-full md:tw-basis-[37%] md:tw-mr-14">
                <h3
                    class="headings-text !tw-font-bold tw-block md:tw-block tw-pl-0 md:tw-pl-5 xl:tw-pl-0 tw-pt-10 md:tw-pt-0"
                >
                    <span class="tw-text-[28px] md:tw-text-[36px] tw-text-[#123D72]"
                        >Selamat datang ke</span
                    ><br />
                    <span class="tw-text-[#F26F31] tw-text-[36px]">
                        imSME
                        <span class="tw-text-[24px]">(beta version)</span></span
                    >
                </h3>
                <div
                    class="!tw-text-[#123D72] tw-h-[10.688rem] tw-pl-0 md:tw-pl-5 lg:tw-pl-5 xl:tw-pl-0 tw-mt-0 xs:tw-mt-8 sm:tw-mt-8 md:tw-mt-8 lg:tw-mt-8 xl:tw-mt-0 content-text tw-mb-10 md:tw-mb-0"
                    
                    [innerHTML]="'ANNOUNCEMENTS.CONTENT' | translate"
                >
                    <span>
                        Laman web versi beta ini merupakan versi awal laman
                        imSME yang akan datang, dan mungkin mengalami isu dengan
                        fungsi atau produk yang tersedia. Laman web ini akan
                        dikemas kini dari semasa ke semasa.</span
                    >
                    <br /><br />
                    <span>
                        Jika anda ingin mengenali produk pinjaman/bantuan
                        kewangan lain, sila kunjungi: imsme.com.my.</span
                    >
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>
